import { useState } from "react";
import { useMediaQuery } from "@mui/material";
import Header from "./components/Header";
import Menu from "./components/Menu";
import Body from "./components/Body";
import Section1 from "./components/Section1";
import Section2 from "./components/Section2";
import Section3 from "./components/Section3";
import Section3Mobile from "./components/Section3Mobile";
import RSVP from "./components/RSVP";
import Success from "./components/Success";

const Home = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSuccess = () => {
    setOpen(false);
    setShowSuccess(true);
  };
  return (
    <div style={{ position: "relative" }}>
      {/* Full-screen header image */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "120vh",
          zIndex: 0,
        }}
      >
        <Header />
      </div>

      {/* Page content that scrolls over the header */}
      <div style={{ position: "relative", zIndex: 1, paddingTop: "120vh" }}>
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 2,
            backGroundColor: "#f2efeb",
          }}
        >
          <Menu />
        </div>
        <Section1 isMobile={isMobile} setOpen={setOpen} />
        <Section2 isMobile={isMobile} setOpen={setOpen} />
        {isMobile ? (
          <Section3Mobile setOpen={setOpen} />
        ) : (
          <Section3 isMobile={isMobile} setOpen={setOpen} />
        )}
        <Body />
      </div>
      <RSVP open={open} close={() => setOpen(false)} onSuccess={handleSuccess}/>
      <Success open={showSuccess} close={() => setShowSuccess(false)} />
    </div>
  );
};

export default Home;
